var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt-face-on-camera-countdown",style:(_vm.colorStyles)},[(!_vm.lastOne)?_c('div',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),(_vm.lastOne)?_c('div',{staticClass:"-lastOne"},[_vm._v("1")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }